export const MASONRY = 'masonry';

export const COLUMN_BREAKPOINTS = {
    default: 4,
    1500: 3,
    768: 2,
};

export const LG_LICENSE_KEY = 'B2F92F7A-0AF54432-BA258D6A-46CF1712';